<template>
   <header id="main-header" data-minimize-offset="80" class="c-layout-header">
    <div class="header-container clearfix">
      <div class="logo-container snipcss0-0-0-1">
        <span class="logo-helper snipcss0-1-1-2"> </span>
        <a
          href="https://www.youroverseashome.com/"
          class="snipcss0-1-1-3 style-RNoqf"
          id="style-RNoqf"
        >
          <img
            src="/assets/img/yoh-logo.png"
            alt="France - Your Overseas Home"
            width="351"
            height="120"
            class="yoh-logo snipcss0-2-3-4"
          />
        </a>
      </div>
      <div class="c-navbar top-navigation">
        <nav class="c-mega-menu top-menu-nav">
          <ul id="top-menu" class="nav navbar-nav">
            <li>
              <a
                href="javascript:void(0);"
                class="nav-link menu-link"
              >
                Property Search&nbsp;
                <i class="fa fa-angle-down"> </i>
              </a>
              <div
                class="dropdown-menu c-menu-type-mega c-menu-type-classic box-shadow"
              >
                <div class="row">
                  <div class="col-md-12 dropdown-column">
                    <ul class="dropdown-menu">
                      <li>
                    <a href="https://www.youroverseashome.com/property-for-sale/france/" target="_blank" countryid="2">
                      France
                    </a>
                  </li>
                  <li>
                    <a href="https://www.youroverseashome.com/property-for-sale/portugal/" target="_blank" countryid="3">
                      Portugal
                    </a>
                  </li>
                  <li>
                    <a href="https://www.youroverseashome.com/property-for-sale/spain/" target="_blank" countryid="4">
                      Spain
                    </a>
                  </li>
                  <li>
                    <a href="https://www.youroverseashome.com/property-for-sale/italy/" target="_blank" countryid="5">
                      Italy
                    </a>
                  </li>
                  <li>
                    <a href="https://www.youroverseashome.com/property-for-sale/greece/" target="_blank" countryid="8">
                      Greece
                    </a>
                  </li>
                  <li>
                    <a href="https://www.youroverseashome.com/property-for-sale/cyprus/" target="_blank"  countryid="9">
                      Cyprus
                    </a>
                  </li>
                    </ul>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <a
                class="nav-link"
                href="https://www.youroverseashome.com/events/"
              >
                Events
              </a>
            </li>
            <li>
              <a
                class="nav-link"
                href="https://www.youroverseashome.com/on-demand/"
              >
                On Demand
              </a>
            </li>
            <li>
              <a
                class="nav-link"
                href="https://www.youroverseashome.com/suppliers/"
              >
                Your Experts
              </a>
            </li>
            <li>
              <a href="javascript:void(0);" class="nav-link menu-link">
                Resources&nbsp;
                <i class="fa fa-angle-down"> </i>
              </a>
              <div
                class="dropdown-menu c-menu-type-mega c-menu-type-classic box-shadow"
              >
                <div class="row">
                  <div class="col-md-12 dropdown-column">
                    <ul class="dropdown-menu">
                      <li>
                        <a
                          href="https://www.youroverseashome.com/property-consultant/"
                        >
                          Property Consultant
                        </a>
                      </li>
                      <li>
                        <a href="https://www.youroverseashome.com/budgeting/">
                          Budgeting Tools
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.youroverseashome.com/property-planner/"
                        >
                          Property Planner
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.youroverseashome.com/viewing-trip-guide/"
                        >
                          Viewing Trip Guide
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.youroverseashome.com/cost-of-living/"
                        >
                          Cost of Living Overseas
                        </a>
                      </li>
                      <li>
                        <a href="https://www.youroverseashome.com/articles/">
                          Articles &amp; News
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <a
                class="nav-link"
                href="https://www.youroverseashome.com/about/"
              >
                About Us
              </a>
            </li>
          </ul>
        </nav>
        <div id="mobile-nav-menu">
          <div class="mobile-nav-bar c-navbar" id="mobile-nav-container">
            <span class="select-page">
              Select Page
            </span>
              <button type="button" class="mobile-menu-bar-toggle c-hor-nav-toggler collapsed" data-toggle="collapse" data-target="#mobile-nav-menu-collapse" aria-expanded="false">
      <span class="mobile-menu-bar fa fa-bars" id="mobile-nav-menu-toggle"></span>
  </button>
            <div class="mobile-menu-container collapse c-navbar-wrapper" id="mobile-nav-menu-collapse" aria-expanded="false" style="height: 0px;">
       <nav class="c-mega-menu mobile-nav c-shown">
           <ul class="mobile-menu nav navbar-nav c-theme-nav">
                  <li>
                    <a class="has-sub-sections">
                      Property Search
                      <span class="c-arrow c-toggler"> </span>
                    </a>
                    <ul class="c-menu-type-classic display-block">
                      <li>
                      <a href="https://www.youroverseashome.com/property-for-sale/france/" target="_blank" countryid="2">
                        France
                      </a>
                    </li>
                    <li>
                      <a href="https://www.youroverseashome.com/property-for-sale/portugal/" target="_blank"  countryid="3">
                        Portugal
                      </a>
                    </li>
                    <li>
                      <a href="https://www.youroverseashome.com/property-for-sale/spain/" target="_blank"  countryid="4">
                        Spain
                      </a>
                    </li>
                    <li>
                      <a href="https://www.youroverseashome.com/property-for-sale/italy/" target="_blank"  countryid="5">
                        Italy
                      </a>
                    </li>
                    <li>
                      <a href="https://www.youroverseashome.com/property-for-sale/greece/" target="_blank"  countryid="8">
                        Greece
                      </a>
                    </li>
                    <li>
                      <a href="https://www.youroverseashome.com/property-for-sale/cyprus/" target="_blank"  countryid="9">
                        Cyprus
                      </a>
                    </li>
                      
                    </ul>
                  </li>
                  <li>
                    <a href="https://www.youroverseashome.com/events/">
                      Events
                    </a>
                  </li>
                  <li>
                    <a href="https://www.youroverseashome.com/on-demand/">
                      On Demand
                    </a>
                  </li>
                  <li>
                    <a href="https://www.youroverseashome.com/suppliers/">
                      Your Experts
                    </a>
                  </li>
                  <li>
                    <a class="has-sub-sections">
                      Resources
                      <span class="c-arrow c-toggler"> </span>
                    </a>
                    <ul class="c-menu-type-classic display-block">
                      <a
                        href="https://www.youroverseashome.com/property-consultant/"
                      >
                        Property Consultant
                      </a>
                      <a href="https://www.youroverseashome.com/budgeting/">
                        Budgeting Tools
                      </a>
                      <a
                        href="https://www.youroverseashome.com/property-planner/"
                      >
                        Property Planner
                      </a>
                      <a
                        href="https://www.youroverseashome.com/viewing-trip-guide/"
                      >
                        Viewing Trip Guide
                      </a>
                      <a
                        href="https://www.youroverseashome.com/cost-of-living/"
                      >
                        Cost of Living Overseas
                      </a>
                      <a href="https://www.youroverseashome.com/articles/">
                        Articles &amp; News
                      </a>
                    </ul>
                  </li>
                  <li>
                    <a href="https://www.youroverseashome.com/about/">
                      About Us
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
   
  </header>
</template>

<script>
export default {
  mounted() {
    var getViewPort= function() {
    var e = window,
        a = 'inner';
    if (!('innerWidth' in window)) {
        a = 'client';
        e = document.documentElement || document.body;
    }

    return {
        width: e[a + 'Width'],
        height: e[a + 'Height']
    };
};

var getBreakpoint= function(size) {
    // bootstrap responsive breakpoints
    var sizes = {
        'xs': 480, // extra small
        'sm': 768, // small
        'md': 992, // medium
        'lg': 1200 // large
    };

    return sizes[size] ? sizes[size] : 0;
}
    var LayoutMegaMenu = function () {

	return {
		//main function to initiate the module
		init: function () {
			$('.c-mega-menu').on('click', '.c-toggler', function (e) {
				if (getViewPort().width < getBreakpoint('md')) {
					e.preventDefault();
					if ($(this).closest("li").hasClass('c-open')) {
						$(this).closest("li").removeClass('c-open');
					} else {
						$(this).closest("li").addClass('c-open');
					}
				}
			});

			$('.c-layout-header .c-hor-nav-toggler:not(.c-quick-sidebar-toggler)').on('click', function () {
				$('.c-layout-header').toggleClass('c-mega-menu-shown');

				if ($('body').hasClass('c-layout-header-mobile-fixed')) {
					var height = getViewPort().height - $('.c-layout-header').outerHeight(true) - 60;
					$('.c-mega-menu').css('max-height', height);
				}
			});
		}
	};
}();
// END

// BEGIN: Layout Mega Menu
var LayoutSidebarMenu = function () {

	return {
		//main function to initiate the module
		init: function () {
			$('.c-layout-sidebar-menu > .c-sidebar-menu .c-toggler').on('click', function (e) {
				e.preventDefault();
                $(this).closest('.c-dropdown').toggleClass('c-open').siblings().removeClass('c-open');
			});
		}
	};
}();
    var LayoutHeader = (function() {
      var offset = parseInt(
        $(".c-layout-header").attr("data-minimize-offset") > 0
          ? parseInt($(".c-layout-header").attr("data-minimize-offset"))
          : 0
      );
      var _handleHeaderOnScroll = function() {
        if ($(window).scrollTop() > offset) {
          $("body").addClass("c-page-on-scroll");
        } else {
          $("body").removeClass("c-page-on-scroll");
        }
      };

      var _handleTopbarCollapse = function() {
        $(".c-layout-header .c-topbar-toggler").on("click", function() {
          $(".c-layout-header-topbar-collapse").toggleClass(
            "c-topbar-expanded"
          );
        });
      };

      return {
        //main function to initiate the module
        init: function() {
          if ($("body").hasClass("c-layout-header-fixed-non-minimized")) {
            return;
          }

          _handleHeaderOnScroll();
          _handleTopbarCollapse();

          $(window).scroll(function() {
            _handleHeaderOnScroll();
          });
        },
      };
    })();

//     var LayoutQuickSidebar = function () {

// 	return {
// 		//main function to initiate the module
// 		init: function () {
// 			// desktop mode
// 			$('.c-layout-header').on('click', '.c-quick-sidebar-toggler', function (e) {
// 				e.preventDefault();
// 				e.stopPropagation();

// 				if ($('body').hasClass("c-layout-quick-sidebar-shown")) {
// 					$('body').removeClass("c-layout-quick-sidebar-shown");
// 				} else {
// 					$('body').addClass("c-layout-quick-sidebar-shown");
// 				}
// 			});

// 			$('.c-layout-quick-sidebar').on('click', '.c-close', function (e) {
// 				e.preventDefault();

// 				$('body').removeClass("c-layout-quick-sidebar-shown");
// 			});

// 			$('.c-layout-quick-sidebar').on('click', function (e) {
// 				e.stopPropagation();
// 			});

// 			$(document).on('click', '.c-layout-quick-sidebar-shown', function () {
// 				$(this).removeClass("c-layout-quick-sidebar-shown");
// 			});
// 		}
// 	};
// }();
    LayoutHeader.init();
    LayoutMegaMenu.init();
    LayoutSidebarMenu.init();
   // LayoutQuickSidebar.init();
  },
};
</script>
